// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"338":"060787d11cea7316","6901":"1d63a150e604a049","8863":"3b4fcaf1e79b4059"}[chunkId] + ".css";
};